import * as React from "react";
const SvgClose = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.47 19.53a.75.75 0 1 0 1.06-1.06L13.06 12l6.47-6.47a.75.75 0 0 0-1.06-1.06L12 10.94 5.53 4.47a.75.75 0 1 0-1.06 1.06L10.94 12l-6.47 6.47a.75.75 0 0 0 1.06 1.06L12 13.06l6.47 6.47Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgClose;
